import get from 'lodash/get'
import { iSchemaDatasV1 } from '../interfaces/iSchemaDataV1'
import { iUIschemaV1 } from '../interfaces/iUIschemaV1'
import { iUiSchemaRuleV1 } from '../interfaces/iUiSchemaRuleV1'
import { UiElTypesInput, UiElTypesLayout } from '../elements/uiElTypes'
import { scopeToScopeWithRepeat } from './calculateDataSchemaArrayScopes'

export interface iUiSchemaDefValue {
  scopeWithRepeat: string
  rules?: iUiSchemaRuleV1[]
  value?: any
  onlyEmpty?: boolean
  arrayCounter?: boolean
  schemaType?: string
}

export const calculateUiSchemaDefaultValues = (
  uiSchema?: iUIschemaV1,
  dataSchema?: iSchemaDatasV1,
  arrayScopes: string[] = [],
) => {
  if (!uiSchema || !dataSchema) {
    return []
  }
  const ret: iUiSchemaDefValue[] = []

  if (uiSchema.scope) {
    const { scopeWithRepeat, dataSchemaPath } = scopeToScopeWithRepeat(uiSchema.scope, arrayScopes)

    const e = {
      scopeWithRepeat: scopeWithRepeat,
      rules: uiSchema.allRules,
    }

    if (uiSchema.type === UiElTypesInput.Hidden) {
      if (uiSchema.options?.fixedValue) {
        ret.push({
          ...e,
          value: uiSchema.options.fixedValue,
        })
      } else if (uiSchema.options?.arrayCounter) {
        const dataSchemaItem = get(dataSchema, dataSchemaPath)
        ret.push({
          ...e,
          arrayCounter: true,
          schemaType: Array.isArray(dataSchemaItem.type) ? dataSchemaItem.type[0] : dataSchemaItem.type,
        })
      }
    } else if ([UiElTypesLayout.Array, UiElTypesLayout.ArrayInline].includes(uiSchema.type)) {
      if (uiSchema.options?.minItems) {
        ret.push({
          ...e,
          value: Array(uiSchema.options.minItems).fill({}),
          onlyEmpty: true,
        })
      }
    }
  }

  uiSchema.elements?.forEach((el) => {
    const childRet = calculateUiSchemaDefaultValues(el, dataSchema, arrayScopes)
    ret.push(...childRet)
  })

  return ret
}
